import React, { useEffect, useState } from "react";
import api from "../services/api";

const DepartamentoDashboard = () => {
  const [resumen, setResumen] = useState({
    pendientes: 0,
    aprobadas: 0,
    rechazadas: 0,
    completadas: 0,
  });

  const [ultimas, setUltimas] = useState([]);
  const [error, setError] = useState(null);
  const [modalDetalle, setModalDetalle] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      // Obtener el usuario completo del localStorage
      const usuarioStr = localStorage.getItem("usuario");
      
      if (!usuarioStr) {
        setError("No hay sesión activa");
        return;
      }

      const usuario = JSON.parse(usuarioStr);
      const depId = usuario.departamento_id;

      if (!depId) {
        setError("Usuario sin departamento asignado");
        return;
      }

      console.log("Cargando datos para departamento:", depId);

      const resResumen = await api.get(`/requisiciones/resumen/${depId}`);
      const resUltimas = await api.get(`/requisiciones/listado/${depId}`);

      setResumen(resResumen.data);
      setUltimas(resUltimas.data);
      setError(null);
    } catch (error) {
      console.error("Error cargando dashboard:", error);
      setError(error.response?.data?.error || "Error al cargar datos");
    }
  };

  const crearRequisicion = () => {
    window.location.href = "/crear-requisicion";
  };

  const verDetalle = async (id) => {
    try {
      setCargandoDetalle(true);
      const res = await api.get(`/requisiciones/${id}`);
      setModalDetalle(res.data);
    } catch (error) {
      console.error("Error al cargar detalle:", error);
      alert("Error al cargar el detalle de la requisición");
    } finally {
      setCargandoDetalle(false);
    }
  };

  const cerrarModal = () => {
    setModalDetalle(null);
  };

  return (
    <div style={styles.container}>
      
      {/* TÍTULO */}
      <h1 style={styles.title}>Dashboard del Departamento</h1>
      <p style={styles.subtitle}>Gestión rápida de requisiciones</p>

      {/* Mostrar error si existe */}
      {error && (
        <div style={styles.errorBanner}>
          ⚠️ {error}
        </div>
      )}

      {/* BOTÓN CREAR */}
      <div style={{ textAlign: "center", marginBottom: "25px" }}>
        <button style={styles.btnCrear} onClick={crearRequisicion}>
          ➕ Crear Requisición
        </button>
      </div>

      {/* TARJETAS RESUMEN */}
      <div style={styles.cardGrid}>
        <div style={styles.card}>
          <h3 style={styles.cardNumber}>{resumen.pendientes}</h3>
          <p style={styles.cardLabel}>Pendientes</p>
        </div>

        <div style={{ ...styles.card, background: "#d1fae5" }}>
          <h3 style={{ ...styles.cardNumber, color: "#065f46" }}>
            {resumen.aprobadas}
          </h3>
          <p style={{ ...styles.cardLabel, color: "#065f46" }}>Aprobadas</p>
        </div>

        <div style={{ ...styles.card, background: "#fee2e2" }}>
          <h3 style={{ ...styles.cardNumber, color: "#991b1b" }}>
            {resumen.rechazadas}
          </h3>
          <p style={{ ...styles.cardLabel, color: "#991b1b" }}>Rechazadas</p>
        </div>

        <div style={{ ...styles.card, background: "#e0f2fe" }}>
          <h3 style={{ ...styles.cardNumber, color: "#0369a1" }}>
            {resumen.completadas}
          </h3>
          <p style={{ ...styles.cardLabel, color: "#0369a1" }}>Completadas</p>
        </div>
      </div>

      {/* TABLA */}
      <div style={styles.tableCard}>
        <h2 style={styles.sectionTitle}>Últimas Requisiciones</h2>

        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>#</th>
                <th style={styles.th}>Código</th>
                <th style={styles.th}>Fecha</th>
                <th style={styles.th}>Descripción</th>
                <th style={styles.th}>Estado</th>
                <th style={styles.th}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {ultimas.length === 0 ? (
                <tr>
                  <td colSpan="6" style={styles.noData}>
                    No hay requisiciones registradas
                  </td>
                </tr>
              ) : (
                ultimas.map((item, index) => (
                  <tr key={index} style={index % 2 === 0 ? styles.trEven : styles.trOdd}>
                    <td style={styles.td}>{item.id}</td>
                    <td style={styles.td}>{item.codigo || `REQ-${item.id}`}</td>
                    <td style={styles.td}>
                      {new Date(item.fecha).toLocaleDateString()}
                    </td>
                    <td style={styles.td}>{item.observaciones || "Sin descripción"}</td>
                    <td style={styles.td}>
                      <span
                        style={
                          ["pendiente", "pendiente_procesar", "PENDIENTE"].includes(item.estado)
                            ? styles.badgePendiente
                            : ["aprobada", "procesada", "APROBADA"].includes(item.estado)
                            ? styles.badgeAprobada
                            : ["rechazada", "RECHAZADA"].includes(item.estado)
                            ? styles.badgeRechazada
                            : styles.badgeCompletada
                        }
                      >
                        {item.estado === "pendiente" || item.estado === "pendiente_procesar" ? "PENDIENTE"
                          : item.estado === "aprobada" || item.estado === "procesada" ? "APROBADA"
                          : item.estado === "rechazada" ? "RECHAZADA"
                          : item.estado === "completada" ? "COMPLETADA"
                          : item.estado}
                      </span>
                    </td>
                    <td style={styles.td}>
                      <button
                        style={styles.btnVer}
                        onClick={() => verDetalle(item.id)}
                      >
                        🔍 Ver
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL DE DETALLE */}
      {modalDetalle && (
        <div style={styles.modalOverlay} onClick={cerrarModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>📋 Detalle de Requisición</h3>
              <button style={styles.btnCerrar} onClick={cerrarModal}>✕</button>
            </div>
            
            <div style={styles.modalBody}>
              {/* Información General */}
              <div style={styles.detalleGrid}>
                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>CÓDIGO:</span>
                  <span style={styles.detalleValue}>{modalDetalle.codigo || `REQ-${modalDetalle.id}`}</span>
                </div>
                
                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>FECHA SOLICITUD:</span>
                  <span style={styles.detalleValue}>
                    {new Date(modalDetalle.fecha_solicitud || modalDetalle.createdAt).toLocaleDateString('es-DO')}
                  </span>
                </div>

                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>DEPARTAMENTO:</span>
                  <span style={styles.detalleValue}>{modalDetalle.departamento || "N/A"}</span>
                </div>

                <div style={styles.detalleItem}>
                  <span style={styles.detalleLabel}>ESTADO:</span>
                  <span style={{
                    ...styles.badge,
                    ...(["pendiente", "pendiente_procesar"].includes(modalDetalle.estado)
                      ? styles.badgePendiente
                      : ["aprobada", "procesada"].includes(modalDetalle.estado)
                      ? styles.badgeAprobada
                      : modalDetalle.estado === "rechazada"
                      ? styles.badgeRechazada
                      : styles.badgeCompletada)
                  }}>
                    {modalDetalle.estado === "pendiente" || modalDetalle.estado === "pendiente_procesar" ? "PENDIENTE"
                      : modalDetalle.estado === "aprobada" || modalDetalle.estado === "procesada" ? "APROBADA"
                      : modalDetalle.estado === "rechazada" ? "RECHAZADA"
                      : modalDetalle.estado === "completada" ? "COMPLETADA"
                      : modalDetalle.estado}
                  </span>
                </div>
              </div>

              {/* Observaciones */}
              {modalDetalle.observaciones && (
                <div style={{marginBottom: '20px'}}>
                  <span style={styles.detalleLabel}>OBSERVACIONES:</span>
                  <p style={{...styles.detalleValue, marginTop: '8px'}}>
                    {modalDetalle.observaciones}
                  </p>
                </div>
              )}

              {/* Materiales Solicitados */}
              {modalDetalle.detalles && modalDetalle.detalles.length > 0 && (
                <div>
                  <h4 style={{...styles.detalleLabel, fontSize: '14px', marginBottom: '15px'}}>
                    MATERIALES SOLICITADOS:
                  </h4>
                  <div style={styles.tableContainer}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.th}>Material</th>
                          <th style={styles.th}>Código</th>
                          <th style={styles.th}>Cantidad</th>
                          <th style={styles.th}>Observación</th>
                        </tr>
                      </thead>
                      <tbody>
                        {modalDetalle.detalles.map((detalle, idx) => (
                          <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                            <td style={styles.td}>{detalle.material?.nombre || "N/A"}</td>
                            <td style={styles.td}>{detalle.material?.codigo || "N/A"}</td>
                            <td style={styles.td}>{detalle.cantidad_solicitada}</td>
                            <td style={styles.td}>{detalle.observacion || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Fecha de Procesamiento */}
              {modalDetalle.fecha_procesada && (
                <div style={{marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #e2e8f0'}}>
                  <span style={styles.detalleLabel}>FECHA PROCESADA:</span>
                  <span style={{...styles.detalleValue, marginLeft: '10px'}}>
                    {new Date(modalDetalle.fecha_procesada).toLocaleDateString('es-DO')}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

// -------------------------------------
// ESTILOS
// -------------------------------------

const styles = {
  container: {
    padding: "25px",
    fontFamily: "'Segoe UI', sans-serif",
    background: "#f8fafc",
    minHeight: "100vh",
  },

  title: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "5px",
    color: "#1e293b",
  },

  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    marginBottom: "20px",
  },

  errorBanner: {
    background: "#fee2e2",
    color: "#991b1b",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "20px",
    border: "1px solid #fecaca",
    textAlign: "center",
    fontWeight: "600",
  },

  btnCrear: {
    padding: "12px 30px",
    background: "#2563eb",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "15px",
    boxShadow: "0 4px 10px rgba(37, 99, 235, 0.3)",
  },

  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    marginBottom: "30px",
  },

  card: {
    background: "white",
    padding: "25px",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
    textAlign: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },

  cardNumber: {
    fontSize: "34px",
    fontWeight: "700",
    marginBottom: "8px",
    color: "#1e293b",
  },

  cardLabel: {
    fontSize: "13px",
    textTransform: "uppercase",
    color: "#64748b",
    fontWeight: "600",
  },

  tableCard: {
    background: "white",
    borderRadius: "12px",
    padding: "25px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },

  sectionTitle: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "20px",
  },

  tableContainer: {
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    padding: "12px",
    textAlign: "left",
    background: "#1e293b",
    color: "white",
    fontSize: "13px",
    fontWeight: "600",
  },

  td: {
    padding: "12px",
    fontSize: "13px",
    color: "#475569",
    borderBottom: "1px solid #e2e8f0",
  },

  trEven: {
    background: "#f8fafc",
  },

  trOdd: {
    background: "white",
  },

  noData: {
    padding: "20px",
    textAlign: "center",
    color: "#64748b",
  },

  btnVer: {
    padding: "6px 12px",
    background: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
  },

  badgePendiente: {
    background: "#fef3c7",
    color: "#92400e",
    padding: "4px 10px",
    borderRadius: "15px",
    fontSize: "11px",
    fontWeight: "700",
  },

  badgeAprobada: {
    background: "#d1fae5",
    color: "#065f46",
    padding: "4px 10px",
    borderRadius: "15px",
    fontSize: "11px",
    fontWeight: "700",
  },

  badgeRechazada: {
    background: "#fee2e2",
    color: "#991b1b",
    padding: "4px 10px",
    borderRadius: "15px",
    fontSize: "11px",
    fontWeight: "700",
  },

  badgeCompletada: {
    background: "#e0f2fe",
    color: "#0369a1",
    padding: "4px 10px",
    borderRadius: "15px",
    fontSize: "11px",
    fontWeight: "700",
  },

  // Estilos del Modal
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },

  modalContent: {
    background: "white",
    borderRadius: "12px",
    width: "90%",
    maxWidth: "700px",
    maxHeight: "90vh",
    overflow: "auto",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 30px",
    borderBottom: "1px solid #e2e8f0",
    background: "#f8fafc",
  },

  modalTitle: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1e293b",
    margin: 0,
  },

  btnCerrar: {
    background: "none",
    border: "none",
    fontSize: "24px",
    color: "#64748b",
    cursor: "pointer",
    padding: "0",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  modalBody: {
    padding: "30px",
  },

  detalleGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "20px",
    marginBottom: "25px",
  },

  detalleItem: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },

  detalleLabel: {
    fontSize: "11px",
    color: "#64748b",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },

  detalleValue: {
    fontSize: "15px",
    color: "#1e293b",
    fontWeight: "500",
  },

  badge: {
    display: "inline-block",
    padding: "4px 12px",
    borderRadius: "15px",
    fontSize: "11px",
    fontWeight: "700",
  },
};

export default DepartamentoDashboard;